export default __webpack_public_path__ + "807832868c6770db5273b81f71599a28.png";